import { connect } from "react-redux";
import FinanceIncentive from "./financeIncentive";
import { bindActionCreators } from "redux";
import { getIncentiveListForFinanceApproval,acceptApproval,rejectApproval } from "services/redux/salesIncentive/action";

const mapStateToProps = (state) => ({
    incentiveListFinance: state.SalesIncentiveReducer.getIncentiveListForFinance,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getIncentiveListForFinanceApproval,
    acceptApproval,
    rejectApproval,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FinanceIncentive);
